import { Box, Typography } from '@mui/material'
import { Fade, IconButton } from 'utoniq-ui'

import { GpsData, Maybe } from '@/clients/utoniq-core/schema'
import { BaseLayout } from '@/components/layouts'
import { FullscreenModal, GpsMap } from '@/components/organisms/functionals'
import { useTranslation } from '@/core'

export type Location = {
  latitude: number
  longitude: number
}

export type GpsClientInfo = {
  permission: boolean
  currentLocation: Maybe<Partial<Location>>
}

type GpsMapData = Maybe<GpsData>

type GpsMapModalProps = {
  title?: string
  targetData?: GpsMapData
  currentData?: GpsClientInfo['currentLocation']
  open: boolean
  onClose: () => void
  isInside: boolean
  hideAnnotation?: boolean
}
/**
 * @description
 * Modal shaped map component (using google map)
 */
export const GpsMapModal = ({
  title,
  targetData,
  currentData,
  open = true,
  onClose = () => {},
  isInside,
  hideAnnotation,
}: GpsMapModalProps) => {
  const { t } = useTranslation('gps')

  return (
    <FullscreenModal open={open} onClose={onClose}>
      <Fade>
        <BaseLayout
          header={{
            title: title || t('area'),
            left: (
              <IconButton.Close
                edge="start"
                size="medium"
                color="inherit"
                onClick={onClose}
              />
            ),
            type: 'modal',
          }}
          sx={{ '.BaseLayoutContent': { height: '100vh' } }}
        >
          {!hideAnnotation && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: 24,
                bgcolor: isInside ? 'primary.main' : 'error.main',
              }}
            >
              <Typography variant="subtitle2" color="white">
                {isInside ? t('areaExist') : t('areaNotExist')}
              </Typography>
            </Box>
          )}

          {!!targetData?.latitude && !!targetData?.longitude && (
            <GpsMap
              targetData={targetData}
              currentData={currentData}
              mapContainerStyle={{
                height: 'calc(100% - 24px)',
                width: '100%',
              }}
              offset={24}
            />
          )}
        </BaseLayout>
      </Fade>
    </FullscreenModal>
  )
}
